import axios from "axios";
import querystring from "querystring"
import {ElMessage} from 'element-plus'
import router from "@/router";
import {replaceLegacyAssetUrlsDeep} from "@/utils/assetUrl";

const instance = axios.create({
    timeout: 30000
})
const isNeedReLogin = code => {
    switch (code) {
        case 4001: //  LOGIN_REQUIRED(4001, "需要登录"),
        case 5001: // SERVER_INTERNAL_ERROR(5001, "系统内部错误"),
        case 4007:
        case 4005: // BANNED_FAIL(4005, "账户被禁用"),
            return true;
        default:
            return false;
    }
}
// 注册发送拦截器
instance.interceptors.request.use(config => {
    config.headers['x-edu-token'] = localStorage.getItem('access_token');

    if (config.methods === "post") {
        config.data = querystring.stringify(config.data);
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject(error);
})
// 注册响应拦截器
instance.interceptors.response.use(resp => {
        if (resp.status === 200 && resp.data.code === 0) {
            return Promise.resolve(replaceLegacyAssetUrlsDeep(resp.data.data));
        }
        if (isNeedReLogin(resp.data.code)) {
            router.replace({
                path: '/login',
                query: {
                    redirect: router.currentRoute.fullPath
                }
            })
        } else {
            ElMessage.error(resp.data.msg);
        }
        return Promise.reject(resp);
    },
    error => {
        return Promise.reject(error);
    }
)
export default instance;
